import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "Modal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modalClass: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  alignLeft: {
    type: Boolean,
    default: false,
  },
  cancelButtonTitle: {
    type: String,
    default: "",
  },
  okButtonTitle: {
    type: String,
    required: true,
  },
},
  emits: ["onClickCancelButton", "onClickOkButton"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const route = useRoute();

const header = ref<HTMLElement>();
const body = ref<HTMLElement>();

const okButton = ref<HTMLElement>();
const hasCancelButton = props.cancelButtonTitle.length > 0;

const showModal = ref(true);
const onClickCancelButton = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  setTimeout(() => {
    emit("onClickCancelButton");
  }, 300);
};

const onClickOkButton = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  setTimeout(() => {
    emit("onClickOkButton");
  }, 300);
};

onMounted(() => {
  if (props.cancelButtonTitle) {
    route.meta.onBackHandlerList.push(onClickCancelButton);
  } else {
    route.meta.onBackHandlerList.push(onClickOkButton);
  }

  if (props.alignLeft) {
    header.value?.classList.add("align-left");
    body.value?.classList.add("align-left");
  }
  if (!hasCancelButton) {
    okButton.value?.classList.add("only");
  }
});

const __returned__ = { props, emit, route, header, body, okButton, hasCancelButton, showModal, onClickCancelButton, onClickOkButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})